import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import ZeroState from 'Modules/Actions/components/ZeroStates/ZeroState';
import { setActiveTab } from 'Modules/Actions/actions';
import { TABS } from 'Modules/Actions/constants/table';

const styles = theme => ({
  link: {
    color: theme.palette.primary.main,
    cursor: 'pointer',
  },
});

@withStyles(styles)
@connect(() => ({}), {
  setActiveTab,
})
export default class FailedZeroState extends Component {
  static propTypes = {
    classes: PropTypes.objectOf(PropTypes.string).isRequired,
    setActiveTab: PropTypes.func.isRequired,
  };

  handleOnClick = () => {
    this.props.setActiveTab({ tab: TABS.ACTIVE });
  };

  render() {
    const { classes } = this.props;

    return (
      <ZeroState
        title="No Failures to Review"
        subtitle={
          <Fragment>
            Return to{' '}
            <span
              className={classes.link}
              onClick={this.handleOnClick}
              role="button"
              tabIndex={-1}
            >
              Active
            </span>
          </Fragment>
        }
      />
    );
  }
}
